import { useState } from "react";
import { api } from "../lib/api";

export default function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.login(password);
      onLogin();
    } catch (e) {
      setErr((e as Error).message === "Unauthorized" ? "Wrong password." : "Login failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-full flex items-center justify-center bg-zinc-950">
      <form
        onSubmit={submit}
        className="card w-full max-w-sm p-8 flex flex-col gap-5"
      >
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Groky</h1>
          <p className="text-sm text-zinc-400 mt-1">Personal Grok Imagine portal.</p>
        </div>
        <input
          autoFocus
          type="password"
          className="input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {err && <p className="text-sm text-rose-400">{err}</p>}
        <button type="submit" className="btn-primary" disabled={busy || !password}>
          {busy ? "Checking…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
